import React, { useContext, useEffect, useRef, useState } from "react";
import FormControl from "../components/form/FormControl";
import { Field, Form, Formik } from "formik";
import SubmitButton from "../components/SubmitButton";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import UploadProduct from "../components/form/UploadProduct";
import usePost from "../customHooks/usePost";
import config from "../services/config.json";
import { MenuActive } from "../context/MenuActiveContext";
import { MyContext } from "../context/MyContext";
import useFetch from "../customHooks/useFetch";
import Loader from "../components/Loader";
import swal from "sweetalert";
import axios from "axios";
import { getTokenSession } from "../utils/common";
import { toast } from "react-toastify";
import { loadStripe } from "@stripe/stripe-js";
import {  Elements, ExpressCheckoutElement} from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);


const CreateProduct = () => {
  const navigate = useNavigate();
  const { setMunuActiv } = useContext(MenuActive);
  const { rolesData } = useContext(MyContext);
  const [shopDetails, setShopDetails] = useState("")
  const { loading: loading2, data: data2 } = useFetch(`viewCategories`)
  const [loading3, setLoading3] = useState(false)
  const isComponentMounted = useRef(true);



  useEffect(() => {
    if (rolesData.role_id === 2) {
      setMunuActiv([true, "ProductManagement"])

    }
    else {
      setMunuActiv([true, "Products"])


      if (isComponentMounted.current) {
        setLoading3(true)
        axios.defaults.headers = {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${getTokenSession()}`,
        };
        axios.get(`${config.apiEndPoint}dashboard/editShop/${rolesData.id}`)
          .then((response) => {
            setLoading3(false)

          })
          .catch((error) => {
            console.log(error.status, "sdkjfdshfjds")
            setLoading3(false)
          });
      }
      return () => {
        isComponentMounted.current = false;
      };

    }

  }, [rolesData])

  const [fileList, setFileList] = useState([
  ]);
  const hanldefileUpdate = (values) => {
    setFileList(values)
  }

  const initialValues = {
    name: "",
    stock: "",
    price: "",
    category_id: "",
    shop_id: rolesData.shop_id,
    condition: 1,
    product_detail: "",
  };


  // const [clientSecret, setClientSecret] = useState("pi_3R520IEK8tzq2qGx0xmoDH6D_secret_nOPXiIIap5BleXZ4b4vXkwibE");
  const [clientSecret, setClientSecret] = useState("");
  const [datatansfer, setDatatansfer] = useState();
  const [res, apiMethod] = usePost()
  const handleSubmit = async (values, { resetForm }) => {
    let ProductData = {
      "name": "",
      "attachments": [],
      "payment_status": "succeed",
      "admin_charges": 50,
    }
    let formdata = new FormData();
    let Feilds = {
      "name": "Product Name",
      "stock": "Quantity in Stock",
      "price": "Price",
      "category_id": "Category",
      "condition": "Condition",
    }
    const requirdFeild = []
    if (fileList.length < 1) {
      requirdFeild.push("Product Images")
    }
    for (let item in values) {
      if (values[item] === "" && Feilds[item]) {
        requirdFeild.push(Feilds[item])
      }
      formdata.append(item, values[item])
      console.log(ProductData)
      ProductData[item] = values[item]
    }
    formdata.append("owner_type", "vendor")
    ProductData["owner_type"] =  "vendor"
    if (requirdFeild.length > 0) {
      swal({
        title: "Must Required",
        text: requirdFeild.join(","),
        icon: "warning",
        dangerMode: true,
      });
    }
    else {
      if (fileList.length) {
        for (let index = 0; index < fileList.length; index++) {
          formdata.append(`attachments[]`, fileList[index]?.originFileObj)
          ProductData["attachments"].push(fileList[index]?.originFileObj)

        }
      }
      axios.post('https://api.stripe.com/v1/payment_intents', {
        amount: 500, // Stripe expects amount in cents, so 200 cents = $2.00
        currency: "aed",
        'payment_method_types[]': 'card',
    }, {
        headers: {
           'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer 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`
        }
    })
    .then(function (response) {
        setClientSecret(response.data.client_secret)
        setBookingModel(true)
        setDatatansfer(ProductData)
    })
    .catch(function (error) {
        console.error(error);
    });

  };



}




  const [bookingModel, setBookingModel] = useState(false)

  const handleOpenModel = (value) => {
    setBookingModel(value)
}
const appearance = {
  theme: 'stripe',
};





  if (loading2 || loading3) return <Loader />
  return (
    <section className="SignInPage">
      <div className=" flex items-center px-10 py-5 productRes ">
        <div className="SignInPage__right_ w-100 h-full">
          <Link to={`/${config.demo}products`} className="arrowArrow flex items-center  gap-2">
            <img src={require("../dist/webImages/arrow-left2.png")} alt="" />
            <span>Add New Product</span>
          </Link>
          <br />
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            <Form name="myForm">
              {rolesData.role_id !== 2 && <Field type="hidden" value={shopDetails} />}
              <UploadProduct updatess={(item) => hanldefileUpdate(item)} filelis={fileList} />
              <div className="SignInPage__rightBox grid grid-cols-2 gap-5">
                <div className="SignInPage__rightBoxl">
                  <FormControl  name="name"  placeholder="Product Name"   label={"Product Name"}  className="w-full"  control="input" />
                  <FormControl  name="part_number"  type={"number"}  placeholder="Part Number"   label={"Part Number"}  className="w-full"   control="input" />
                  <FormControl   name="car_brand" type={"text"}   placeholder="Car Brand"  label={"Car Brand"}  className="w-full"  control="input"  />
                  <FormControl  name="model"   type={"text"}  placeholder="Model"  label={"Model"}   className="w-full"  control="input"  />
                  <FormControl   name="year"   type={"number"}   placeholder="Year"  label={"Year"}   className="w-full"   control="input"  />
                  <FormControl  name="v_number"  label={"V4/V6/V8"}  className="w-full"  control="input"  placeholder="V4/V6/V8"  />
                  <FormControl name="product_detail" placeholder="Product Details" label={"Product Details"} className="w-full" control="textarea" />
                </div>
                <div className="SignInPage__rightBoxr">
                  <FormControl  name="category_id"   label={"Category"}  className="w-full"  control="select"  custom_label_name={"name"}   firstSelect={"Category"}  customer_value_name={"id"}
                    selectList={[
                      {
                        "name": "engine",
                        "id": "1",
                      },
                      {
                        "name": "powertrain&chassis",
                        "id": "2",
                      },
                      {
                        "name": "electrical",
                        "id": "3",
                      },
                      {
                        "name": "body",
                        "id": "4",
                      },
                      {
                        "name": "transmission",
                        "id": "5",
                      },
                      {
                        "name": "AC",
                        "id": "6",
                      },
                    ]}
                  />
                  <FormControl  name="condition"   label={"Condition"}  className="w-full"   control="select"  custom_label_name={"name"}  customer_value_name={"id"}
                    selectList={[
                      {
                        "name": "used",
                        "id": "1",
                      },
                      {
                        "name": "new",
                        "id": "2",
                      },
                    ]}
                  />

                  <div className="checkc mt-3">
                    <div className="checkc_">
                      <div className="flex flex-wrap gap-4">
                        <label className="flex gap-1">
                          <Field type="radio" name="part_type" value="1" />
                          Genuine
                        </label>
                        <label className="flex gap-1">
                          <Field type="radio" name="part_type" value="2" />
                          After Market
                        </label>
                      </div>
                    </div>
                  </div>
                  <FormControl  name="price"   placeholder="Price"  label={"Price"}  className="w-full"   control="input"   type="number"  />
                  <FormControl  name="stock"  type={"number"}  placeholder="Quantity"   label={"Quantity in Stock"}  className="w-full"  control="input"  />
                  <SubmitButton
                    props={{
                      class: "btn btn-primary  block mt-5 submit",
                      text: "Submit",
                    }}
                  />
                </div>
                <div>

                </div>
              </div>


            </Form>
          </Formik>
        </div>
      </div>
      <div onClick={() => handleOpenModel(false)} className={`fixedback ${bookingModel ? "active" : ""}`}></div>
      {bookingModel && 
      <div className={`consModel bg-[#fff]  w-[50%] fixed top-[50%] transform translate-y-[-50%] scale-x-0 transition-all duration-300 mx-auto left-0 right-0 z-[999] ${bookingModel ? "active" : ""}`} >

<Elements options={{clientSecret, appearance}} stripe={stripePromise}>
<CheckoutForm onModelCLose={() => handleOpenModel(false)} data={datatansfer} />
    </Elements>
      </div>
      }
    </section>
  );
};

export default CreateProduct;



